

// AITranslations.js

const AITranslations = {
  en: {
    cogsiggraph: "Cognitive Signal Graph",
    aiInsightsSignals: "AI Insights / AI Signals",
    aiInsightsDesc: "Contextual operational intelligence, cognitive AI, autonomous agents, operational diagnostics, and risk signals.",
    as: "As a",
    student: "Student",
    parent: "Parent",
    manager: "Manager",
    owner: "Owner",
    mess: "Mess",
    transporter: "Transporter",
    institution: "Institution",
    huma: "HUMA",
    director: "Director",
    admin: "Admin",
    coordinator: "Coordinator",
    trustee: "Trustee",
    realtimeai: "Real-time AI cognitive diagnostics",
    thinkingcognitively: "Thinking cognitively..."
  },

  hi: {
    cogsiggraph: "कॉग्निटिव सिग्नल ग्राफ",
    aiInsightsSignals: "AI अंतर्दृष्टि / AI संकेत",
    aiInsightsDesc: "संदर्भित संचालन बुद्धिमत्ता, कॉग्निटिव AI, स्वायत्त एजेंट्स, संचालन निदान एवं जोखिम संकेत।",
    as: "यथा",
    student: "छात्र",
    parent: "अभिभावक",
    manager: "प्रबंधक",
    owner: "मालिक",
    mess: "भोजनालय",
    transporter: "परिवहनकर्ता",
    institution: "संस्थान",
    huma: "HUMA",
    director: "निदेशक",
    admin: "प्रशासक",
    coordinator: "समन्वयक",
    trustee: "न्यासकर्ता",
    realtimeai: "रीयल-टाइम एआई संज्ञानात्मक निदान",
    thinkingcognitively: "संज्ञानात्मक रूप से विचार कर रहा है..."
  },

  mr: {
    cogsiggraph: "कॉग्निटिव सिग्नल ग्राफ",
    aiInsightsSignals: "एआय अंतर्दृष्टी / एआय संकेत",
    aiInsightsDesc: "संदर्भित ऑपरेशनल बुद्धिमत्ता, कॉग्निटिव एआय, स्वायत्त एजंट्स, ऑपरेशनल निदान आणि जोखीम संकेत.",
    as: "म्हणून",
    student: "विद्यार्थी",
    parent: "पालक",
    manager: "व्यवस्थापक",
    owner: "मालक",
    mess: "भोजनालय",
    transporter: "वाहतूकदार",
    institution: "संस्था",
    huma: "HUMA",
    director: "संचालक",
    admin: "प्रशासक",
    coordinator: "समन्वयक",
    trustee: "विश्वस्त",
    realtimeai: "रीयल-टाइम एआय संज्ञानात्मक निदान",
    thinkingcognitively: "संज्ञानात्मक विचार करत आहे..."
  },

  gu: {
    cogsiggraph: "કૉગ્નિટિવ સિગ્નલ ગ્રાફ",
    aiInsightsSignals: "એઆઈ અંતર્દૃષ્ટિ / એઆઈ સંકેતો",
    aiInsightsDesc: "સંદર્ભિત ઓપરેશનલ ઇન્ટેલિજન્સ, કૉગ્નિટિવ એઆઈ, સ્વાયત્ત એજન્ટ્સ, ઓપરેશનલ ડાયગ્નોસ્ટિક્સ અને જોખમ સંકેતો.",
    as: "રૂપે",
    student: "વિદ્યાર્થી",
    parent: "વાલી",
    manager: "મેનેજર",
    owner: "માલિક",
    mess: "મેસ",
    transporter: "પરિવહનકાર",
    institution: "સંસ્થા",
    huma: "HUMA",
    director: "નિર્દેશક",
    admin: "પ્રશાસક",
    coordinator: "સમન્વયક",
    trustee: "ટ્રસ્ટી",
    realtimeai: "રીયલ-ટાઇમ એઆઈ સંજ્ઞાનાત્મક નિદાન",
    thinkingcognitively: "સંજ્ઞાનાત્મક રીતે વિચારી રહ્યું છે..."
  },

  bn: {
    cogsiggraph: "কগনিটিভ সিগন্যাল গ্রাফ",
    aiInsightsSignals: "এআই অন্তর্দৃষ্টি / এআই সংকেত",
    aiInsightsDesc: "প্রাসঙ্গিক অপারেশনাল ইন্টেলিজেন্স, কগনিটিভ এআই, স্বায়ত্তশাসিত এজেন্ট, অপারেশনাল ডায়াগনস্টিকস এবং ঝুঁকি সংকেত।",
    as: "হিসেবে",
    student: "ছাত্র",
    parent: "অভিভাবক",
    manager: "ম্যানেজার",
    owner: "মালিক",
    mess: "মেস",
    transporter: "পরিবহনকারী",
    institution: "প্রতিষ্ঠান",
    huma: "HUMA",
    director: "পরিচালক",
    admin: "প্রশাসক",
    coordinator: "সমন্বয়কারী",
    trustee: "ট্রাস্টি",
    realtimeai: "রিয়েল-টাইম এআই কগনিটিভ ডায়াগনস্টিকস",
    thinkingcognitively: "জ্ঞানগতভাবে চিন্তা করছে..."
  },

  ta: {
    cogsiggraph: "அறிவுசார் சிக்னல் வரைபடம்",
    aiInsightsSignals: "ஏஐ உள்ளடக்கம் / ஏஐ சிக்னல்கள்",
    aiInsightsDesc: "சூழ்நிலை செயல்பாட்டு நுண்ணறிவு, அறிவுசார் ஏஐ, தன்னாட்சி முகவர்கள், செயல்பாட்டு நோயறிதல் மற்றும் அபாய சிக்னல்கள்.",
    as: "ஆக",
    student: "மாணவர்",
    parent: "பெற்றோர்",
    manager: "மேலாளர்",
    owner: "உரிமையாளர்",
    mess: "மெஸ்",
    transporter: "போக்குவரத்தாளர்",
    institution: "நிறுவனம்",
    huma: "HUMA",
    director: "இயக்குநர்",
    admin: "நிர்வாகி",
    coordinator: "ஒழுங்குபடுத்துபவர்",
    trustee: "நம்பிக்கைத் தலைவர்",
    realtimeai: "நேரடி ஏஐ அறிவுசார் நோயறிதல்",
    thinkingcognitively: "அறிவுசார் முறையில் சிந்திக்கிறது..."
  },

  te: {
    cogsiggraph: "కాగ్నిటివ్ సిగ్నల్ గ్రాఫ్",
    aiInsightsSignals: "ఏఐ అంతర్దృష్టులు / ఏఐ సంకేతాలు",
    aiInsightsDesc: "సందర్భాత్మక ఆపరేషనల్ ఇంటెలిజెన్స్, కాగ్నిటివ్ ఏఐ, స్వయంచాలక ఏజెంట్లు, ఆపరేషనల్ డయాగ్నస్టిక్స్ మరియు రిస్క్ సంకేతాలు.",
    as: "గా",
    student: "విద్యార్థి",
    parent: "తల్లిదండ్రులు",
    manager: "మేనేజర్",
    owner: "యజమాని",
    mess: "మెస్",
    transporter: "రవాణాదారు",
    institution: "సంస్థ",
    huma: "HUMA",
    director: "నిర్దేశకుడు",
    admin: "నిర్వాహకుడు",
    coordinator: "కోఆర్డినేటర్",
    trustee: "ట్రస్టీ",
    realtimeai: "రీయల్-టైమ్ ఏఐ కాగ్నిటివ్ డయాగ్నోస్టిక్స్",
    thinkingcognitively: "కాగ్నిటివ్‌గా ఆలోచిస్తోంది..."
  },

  kn: {
    cogsiggraph: "ಕಾಗ್ನಿಟಿವ್ ಸಿಗ್ನಲ್ ಗ್ರಾಫ್",
    aiInsightsSignals: "ಎಐ ಒಳನೋಟಗಳು / ಎಐ ಸಂಕೇತಗಳು",
    aiInsightsDesc: "ಸಂದರ್ಭಾತ್ಮಕ ಕಾರ್ಯಾಚರಣಾ ಬುದ್ಧಿಮತ್ತೆ, ಕಾಗ್ನಿಟಿವ್ ಎಐ, ಸ್ವಾಯತ್ತ ಏಜೆಂಟ್‌ಗಳು, ಕಾರ್ಯಾಚರಣಾ ಡಯಾಗ್ನೋಸ್ಟಿಕ್ಸ್ ಮತ್ತು ಅಪಾಯ ಸಂಕೇತಗಳು.",
    as: "ಆಗಿ",
    student: "ವಿದ್ಯಾರ್ಥಿ",
    parent: "ಪೋಷಕರು",
    manager: "ವ್ಯವಸ್ಥಾಪಕ",
    owner: "ಮಾಲೀಕ",
    mess: "ಮೆಸ್",
    transporter: "ಸಾರಿಗೆಗಾರ",
    institution: "ಸಂಸ್ಥೆ",
    huma: "HUMA",
    director: "ನಿರ್ದೇಶಕ",
    admin: "ನಿರ್ವಹಣಾಧಿಕಾರಿ",
    coordinator: "ಸಮನ್ವಯಕ",
    trustee: "ಟ್ರಸ್ಟಿ",
    realtimeai: "ರಿಯಲ್-ಟೈಮ್ ಏಐ ಕಾಗ್ನಿಟಿವ್ ಡಯಾಗ್ನೋಸ್ಟಿಕ್ಸ್",
    thinkingcognitively: "ಜ್ಞಾನಾತ್ಮಕವಾಗಿ ಯೋಚಿಸುತ್ತಿದೆ..."
  },

  ml: {
    cogsiggraph: "കോഗ്നിറ്റീവ് സിഗ്നൽ ഗ്രാഫ്",
    aiInsightsSignals: "എഐ ഉൾക്കാഴ്ചകൾ / എഐ സിഗ്നലുകൾ",
    aiInsightsDesc: "സന്ദർഭാത്മക പ്രവർത്തന ബുദ്ധിമत्ता, കോഗ്നിറ്റീവ് എഐ, സ്വയംഭരണ ഏജന്റുകൾ, പ്രവർത്തന രോഗനിർണയം, അപകട സൂചനകൾ.",
    as: "ആയി",
    student: "വിദ്യാർത്ഥി",
    parent: "മാതാപിതാക്കൾ",
    manager: "മാനേജർ",
    owner: "ഉടമ",
    mess: "മെസ്",
    transporter: "ഗതാഗതക്കാരൻ",
    institution: "സ്ഥാപനം",
    huma: "HUMA",
    director: "ഡയറക്ടർ",
    admin: "അഡ്മിൻ",
    coordinator: "കോഓർഡിനേറ്റർ",
    trustee: "ട്രസ്റ്റി",
    realtimeai: "റിയൽ-ടൈം എഐ കോഗ്നിറ്റീവ് ഡയഗ്നോസ്റ്റിക്സ്",
    thinkingcognitively: "ബൗദ്ധികമായി ചിന്തിക്കുന്നു..."
  },

  pa: {
    cogsiggraph: "ਕੌਗਨਿਟਿਵ ਸਿਗਨਲ ਗ੍ਰਾਫ",
    aiInsightsSignals: "ਏਆਈ ਅੰਦਰੂਨੀ ਜਾਣਕਾਰੀ / ਏਆਈ ਸੰਕੇਤ",
    aiInsightsDesc: "ਸੰਦਰਭਤ ਆਪਰੇਸ਼ਨਲ ਇੰਟੈਲੀਜੈਂਸ, ਕੌਗਨਿਟਿਵ ਏਆਈ, ਸੁਤੰਤਰ ਏਜੰਟ, ਆਪਰੇਸ਼ਨਲ ਡਾਇਗਨੋਸਟਿਕਸ ਅਤੇ ਜੋਖਮ ਸੰਕੇਤ।",
    as: "ਵਜੋਂ",
    student: "ਵਿਦਿਆਰਥੀ",
    parent: "ਮਾਤਾ-ਪਿਤਾ",
    manager: "ਪ੍ਰਬੰਧਕ",
    owner: "ਮਾਲਕ",
    mess: "ਮੇਸ",
    transporter: "ਪਰਿਵਾਹਕ",
    institution: "ਸੰਸਥਾ",
    huma: "HUMA",
    director: "ਨਿਰਦੇਸ਼ਕ",
    admin: "ਪ੍ਰਸ਼ਾਸਕ",
    coordinator: "ਸਮਨਵਯਕ",
    trustee: "ਟ੍ਰਸਟੀ",
    realtimeai: "ਰੀਅਲ-ਟਾਈਮ ਏਆਈ ਕੌਗਨਿਟਿਵ ਡਾਇਗਨੋਸਟਿਕਸ",
    thinkingcognitively: "ਕੌਗਨਿਟਿਵ ਤੌਰ 'ਤੇ ਸੋਚ ਰਿਹਾ ਹੈ..."
  },

  as: {
    cogsiggraph: "কগনিটিভ সিগনেল গ্ৰাফ",
    aiInsightsSignals: "এআই অন্তর্দৃষ্টি / এআই সংকেত",
    aiInsightsDesc: "প্ৰাসংগিক অপাৰেশ্যনেল ইন্টেলিজেন্স, কগনিটিভ এআই, স্বায়ত্তশাসিত এজেন্ট, অপাৰেশ্যনেল ডায়াগনষ্টিক্স আৰু বিপদ সংকেত।",
    as: "ৰূপে",
    student: "ছাত্ৰ",
    parent: "অভিভাৱক",
    manager: "ব্যৱস্থাপক",
    owner: "মালিক",
    mess: "মেছ",
    transporter: "পৰিবহনকাৰী",
    institution: "সংস্থা",
    huma: "HUMA",
    director: "পৰিচালক",
    admin: "প্ৰশাসক",
    coordinator: "সমন্বয়ক",
    trustee: "ট্ৰাষ্টী",
    realtimeai: "ৰিয়েল-টাইম এআই কগনিটিভ ডায়াগনস্টিক্স",
    thinkingcognitively: "জ্ঞানগতভাৱে চিন্তা কৰি আছে..."
  },
};

export default AITranslations;
